import React from 'react';
import Begin from '@component/gridgio/home/begin';
import PageTemplate from '@page/gridgio/page-template';
import Scroll from '@component/common/scroll';
import * as color from '@constant/color';

const HomeBeginPage: React.FC = () => (
  <PageTemplate customHeader='none' title='홈' mode='page' backgroundColor={color.GRAY_BACKGROUND_COLOR}>
    <Scroll direction='y' height='100%'>
      <Begin />
    </Scroll>
  </PageTemplate>
);

export default HomeBeginPage;
